import { combineReducers } from 'redux';
import basket from './basket'
import auth from './auth'
import orders from './orders'

export default combineReducers({  basket, auth, orders });